import React, { useEffect, useRef, useState } from 'react'
import Navbar from '../../components/Navbar';
import { PrimaryButton, PrimaryButton2th, SecondaryButton } from '../../components/StyledButtons';
import USTH_logo from "../../assets/images/brands/USTH-logo.svg"
import vanlang_logo from "../../assets/images/brands/vanlang-logo.svg"
import IUH_logo from "../../assets/images/brands/IUH-logo.svg"
import PTIT_logo from "../../assets/images/brands/PTIT-logo.svg"
import UEH_logo from "../../assets/images/brands/UEH-logo.svg"
import UIT_logo from "../../assets/images/brands/UIT-logo.svg"
import TDT_logo from "../../assets/images/brands/TDT-logo.svg"
import icon_qr_code from "../../assets/images/icons/qr_code_80px.svg"
import icon_money_inscreases from "../../assets/images/icons/money_increases_80px.svg"
import icon_shield_checked from "../../assets/images/icons/shield_check_80px.svg"
import icon_golf_goal from "../../assets/images/icons/golf_goal_80px.svg"
import icon_heart_broken from "../../assets/images/icons/heart_broken_80px.svg"
import icon_education from "../../assets/images/icons/education_80px.svg"
import icon_arrow_right from "../../assets/images/icons/arrow_24px_right.svg"
import document_img from "../../assets/images/contents/home-img.png"
import deployment_img from "../../assets/images/contents/home-img-2.png"
import icon_checked_red from "../../assets/images/icons/checked_24px_red.svg"
import icon_star_checked from "../../assets/images/icons/checked_star_red_80px.svg"
import icon_checked_shield_red from "../../assets/images/icons/checked_shield_red_80px.svg"
import icon_hand_book from "../../assets/images/icons/hand_open_book_80px.svg"
import icon_arrow_tv from "../../assets/images/icons/arrow_tv_80px.svg"
import icon_cloud_lifecycle from "../../assets/images/icons/cloud_lifecyle_80px.svg"
import icon_hammer_wrench from "../../assets/images/icons/hammer_wrench_80px.svg"
import icon_paper_red from "../../assets/images/icons/paper_red_80px.svg"
import icon_database from "../../assets/images/icons/database_80px.svg"
import HomeCarousel from './HomeCarousel';
import HomeSlider from './HomeSlider';
import UEH_color_logo from "../../assets/images/brands/UEH-color-logo.svg"
import UIT_color_logo from "../../assets/images/brands/UIT-color-logo.svg"
import TDT_color_logo from "../../assets/images/brands/TDT-color-logo.svg"
import HUTECH_color_logo from "../../assets/images/brands/HUTECH-color-logo.svg"
import VANLANG_color_logo from "../../assets/images/brands/vanlang-color-logo.svg"
import USTH_color_logo from "../../assets/images/brands/USTH-color-logo.svg"
import FPT_color_logo from "../../assets/images/brands/FPT-color-logo.svg"
import VNU_color_logo from "../../assets/images/brands/VNU-color-logo.svg"
import PTIT_color_logo from "../../assets/images/brands/PTIT-color-logo.svg"
import BK_color_logo from "../../assets/images/brands/BK-color-logo.svg"
import Footer from '../../components/Footer';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
import { selectLanguage } from './../../redux/language/selector';
import HomeTabCarousel from './HomeTabCarousel';
import { StyledLink } from '../../components/StyledComponents';
import ModalContactDiscussionForm from '../../components/ModalContactDiscussionForm';


const Home = () => {
  const language = useSelector(selectLanguage)

  useEffect(() => {
    document.title = t('web-title.home');
    // eslint-disable-next-line
  }, [language])

  const { t } = useTranslation()

  useEffect(() => {
    if (localStorage.getItem("i18nextLng")?.length > 2) {
      i18n.changeLanguage("en");
    }
  }, [])

  const [modalDiscussionOpen, setModalDiscussionOpen] = useState(false);

  const modalDiscussionRef = useRef(null);

  const handleOverlayClick = (event) => {
    if (modalDiscussionRef.current && !modalDiscussionRef.current.contains(event.target)) {
      setModalDiscussionOpen(false);
    }
  };

  document.onkeydown = function (evt) {
    if (evt.code === 'Escape') {
      setModalDiscussionOpen(false)
    }
  };



  const [mousePosition1, setMousePosition1] = useState({ x: 0, y: 0 });

  const [mousePosition2, setMousePosition2] = useState({ x: 0, y: 0 });

  const handleMouseMove1 = (e) => {
    setMousePosition1({ x: e.nativeEvent.clientX, y: e.nativeEvent.clientY });
  };

  const handleMouseMove2 = (e) => {
    setMousePosition2({ x: e.nativeEvent.clientX, y: e.nativeEvent.clientY });
  };

  return (
    <div className='home'>
      <Navbar />
      <div className='bg-home-header'>
        <div className='container-fluid home-header'>
          {language === "en" ?
            <div className='col-sm-10 col-sm-offset-1'>
              <p className='pt-150 pt-md-230 text-center font-96 font-weight-bold text-primary-orange'>Document Security</p>
              <p className='text-center font-96 font-weight-bold text-white'>Reimagined</p>
            </div>
            :
            <div className='col-sm-12'>
              <p className='pt-230 text-center font-96 font-weight-bold text-primary-orange'>
                Bảo Mật Tài Liệu
              </p>
              <p className='text-center font-96 font-weight-bold text-white'>
                Được Mô Phỏng
              </p>
            </div>
          }
          <div className='col-sm-12'>
            <p className='text-center pt-30 text-white'>{t('home-page.header.sub-title')}</p>
            <div className='pb-md-250 flex justify-center flex-wrap gap-20 pt-30 pb-100'>
              <PrimaryButton onClick={() => setModalDiscussionOpen(true)}>{t('button.schedule-discussion')}</PrimaryButton>
              <SecondaryButton href="/technology">{t('button.learn-more')}</SecondaryButton>
            </div>
          </div>
        </div>

      </div>


      <div className='home-content bg-primary'>
        <div className='organzi-brands container pt-100 pb-100'>
          {language === "en" ?
            <p className='font-42 font-weight-semi-bold text-center text-white'>Leading <span className='text-primary-orange'>organizations and brands </span>rely on Qrypto</p>
            :
            <div className='col-sm-12'>
              <p className='font-42 font-weight-semi-bold text-center text-white'><span className='text-primary-orange'>Các tổ chức và thương hiệu hàng đầu</span> tin tưởng vào Qrypto</p>
            </div>
          }
          <div className='col-sm-12'>
            <p className='text-center text-white pb-50 pt-20'>{t("home-page.organizations.sub-title")}</p>
          </div>
          <div className='image-container'>
            <div className='image-container_list'>
              <img src={TDT_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-120' />
              <img src={UIT_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-120' />
              <img src={UEH_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-120' />
              <img src={IUH_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-120' />
              <img src={vanlang_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-120' />
              <img src={PTIT_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-120' />
              <img src={USTH_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s-120' />
            </div>
            <div className='image-container_list'>
              <img src={TDT_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s' />
              <img src={UIT_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s' />
              <img src={UEH_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s' />
              <img src={IUH_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s' />
              <img src={vanlang_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s' />
              <img src={PTIT_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s' />
              <img src={USTH_logo} alt="USTH-logo" className='image-container_list__item img-responsive client-s' />
            </div>
          </div>
          <div className='flex justify-center pt-50'>
            <PrimaryButton onClick={() => setModalDiscussionOpen(true)}>{t('button.schedule-discussion')}</PrimaryButton>
          </div>
        </div>

        <div className='industries-benefiting container'>
          {language === "en" ?
            <div className='text-center col-sm-10 col-sm-offset-1'>
              <p className='font-42 font-weight-semi-bold text-white'><span className='text-primary-orange'>Industries </span>benefiting from Qrypto</p>
              <p className='text-gray pt-20'>Qrypto’s aim is to enable information sharing through documents <strong>with full trust, security</strong> and <strong>privacy</strong> in the most user friendly manner with <strong>high efficiency</strong> to save on costs and time.</p>
            </div>
            :
            <div className='text-center col-sm-10 col-sm-offset-1'>
              <p className='font-42 font-weight-semi-bold text-white'><span className='text-primary-orange'>Lợi ích </span>của Qrypto dành cho các ngành công nghiệp</p>
              <p className='text-gray pt-20'>Mục đích của Qrypto là cho phép chia sẻ thông tin thông qua các tài liệu với <strong>sự tin cậy</strong>, <strong>bảo mật</strong> và <strong>quyền riêng tư</strong> hoàn toàn theo cách thân thiện với người dùng nhất với <strong>hiệu quả cao</strong> để tiết kiệm chi phí và thời gian.</p>
            </div>
          }
          <div className='industries-card col-sm-12 px-0'>
            <div className='row'>
              <div className='col-md-12 col-lg-6 pt-50'>
                <StyledLink href="/industries/general-and-hr">
                  <div className='industries-card_item'>
                    <div className='flex justify-spacebetween'>
                      <p className='font-24 text-primary-cyan'>{t('home-page.industries.general')}
                        <span><img src={icon_arrow_right} alt='arrow_right' className='mb--5 scale-img' /></span></p>
                      <img src={icon_qr_code} alt="qr_code" className='client-s-80' />
                    </div>
                    <div className='pt-50'>
                      <p className='font-20 text-gray'>{t('home-page.industries.general-content')}</p>
                    </div>
                  </div>
                </StyledLink>
              </div>
              <div className='col-md-12 col-lg-6 pt-50'>
                <StyledLink href="/industries/banking-and-financial">
                  <div className='industries-card_item'>
                    <div className='flex justify-spacebetween'>
                      <p className='font-24 text-primary-cyan'>{t('home-page.industries.banking-financial')}
                        <span><img src={icon_arrow_right} alt='arrow_right' className='mb--5 scale-img' /></span></p>
                      <img src={icon_money_inscreases} alt="money_inscreases" className='client-s-80' />
                    </div>
                    <div className='pt-50'>
                      <p className='font-20 text-gray'>{t('home-page.industries.banking-financial-content')}</p>
                    </div>
                  </div>
                </StyledLink>
              </div>
              <div className='col-md-12 col-lg-6 pt-50'>
                <StyledLink href="/industries/insurance">
                  <div className='industries-card_item'>
                    <div className='flex justify-spacebetween'>
                      <p className='font-24 text-primary-cyan'>{(t('home-page.industries.insurance'))}
                        <span><img src={icon_arrow_right} alt='arrow_right' className='mb--5 scale-img' /></span></p>
                      <img src={icon_shield_checked} alt="shield_checked" className='client-s-80' />
                    </div>
                    <div className='pt-50'>
                      <p className='font-20 text-gray'>{(t('home-page.industries.insurance-content'))}</p>
                    </div>
                  </div>
                </StyledLink>
              </div>
              <div className='col-md-12 col-lg-6 pt-50'>
                <StyledLink href="/industries/government">
                  <div className='industries-card_item'>
                    <div className='flex justify-spacebetween'>
                      <p className='font-24 text-primary-cyan'>{(t('home-page.industries.govt-regulators'))}
                        <span><img src={icon_arrow_right} alt='arrow_right' className='mb--5 scale-img' /></span></p>
                      <img src={icon_golf_goal} alt="golf_goal" className='client-s-80' />
                    </div>
                    <div className='pt-50'>
                      <p className='font-20 text-gray'>{(t('home-page.industries.govt-regulators-content'))}</p>
                    </div>
                  </div>
                </StyledLink>
              </div>
              <div className='col-md-12 col-lg-6 pt-50'>
                <StyledLink href="/industries/healthcare">
                  <div className='industries-card_item'>
                    <div className='flex justify-spacebetween'>
                      <p className='font-24 text-primary-cyan'>{t('home-page.industries.healthcare')}
                        <span><img src={icon_arrow_right} alt='arrow_right' className='mb--5 scale-img' /></span></p>
                      <img src={icon_heart_broken} alt="heart_broken" className='client-s-80' />
                    </div>
                    <div className='pt-50'>
                      <p className='font-20 text-gray'>{t('home-page.industries.healthcare-content')}</p>
                    </div>


                  </div>
                </StyledLink>
              </div>
              <div className='col-md-12 col-lg-6 pt-50'>
                <StyledLink href="/industries/education">
                  <div className='industries-card_item'>
                    <div className='flex justify-spacebetween'>
                      <p className='font-24 text-primary-cyan'>{t('home-page.industries.education')}
                        <span><img src={icon_arrow_right} alt='arrow_right' className='mb--5 scale-img' /></span></p>
                      <img src={icon_education} alt="education" className='client-s-80' />
                    </div>
                    <div className='pt-50'>
                      <p className='font-20 text-gray'>{t('home-page.industries.education-content')}</p>
                    </div>
                  </div>
                </StyledLink>
              </div>
            </div>
          </div>
        </div>

        <div className='secure-document container pt-100' >
          <div className='col-md-8 col-md-offset-2 text-center'>
            {language === "en" ?
              <p className='font-42 text-white font-weight-semi-bold'>The only <span className='text-primary-orange'>secure document</span> generation solution you need</p>
              :
              <p className='font-42 text-white font-weight-semi-bold'>Giải pháp tạo <span className='text-primary-orange'>tài liệu an toàn</span> duy nhất bạn cần</p>
            }
          </div>

          <div className='secure-document_content bg-dark-blue col-md-12 mt-50 p-x30-y50' onMouseMove={handleMouseMove1}>
            <div className='blur-white' style={{
              left: mousePosition1.x - 500 + 'px',
              top: mousePosition1.y - 500 + 'px'
            }} />
            <div className='col-md-5 index-10'>
              <img src={document_img} alt='document' className='document-img img-responsive' />
            </div>
            {language === "en" ?
              <div className='col-md-7 pl-md-30 index-10'>
                <p className='text-white font-24 pt-sm-20'>For all documents which need <strong>validation</strong></p>
                <p className='text-white pt-20'>For all documents which need validation Engineered from the ground up to be the one and only <strong>secure document</strong> generation solution you need. The solution can be used for all kinds of documents which may need to be verified.</p>
                <p className='text-white pt-30'>Qrypto is a truly multi-purposed design, suitable for <strong>educational</strong>, <strong>corporate</strong> or <strong>government environments</strong>. It is a light weight system which can be easily integrated with your existing <strong>document production processes</strong>. The best part is that our mobile Apps make it very easy for any person to <strong>instantly validate</strong> both <strong>physical</strong> and <strong>electronic documents.</strong></p>
                <p className='text-white pt-30'>A system that just works!</p>
                <PrimaryButton href='/industries' className='mt-20'>Learn More</PrimaryButton>
              </div>
              :
              <div className='col-md-7 pl-md-30 index-10'>
                <p className='text-white font-24 pt-20'>Đối với tất cả các tài liệu cần <strong>sự thẩm định</strong></p>
                <p className='text-white pt-20'>Dành cho tất cả tài liệu cần xác thực. Được thiết kế ngay từ đầu để trở thành giải pháp tạo <strong>tài liệu an toàn</strong> duy nhất mà bạn cần. Giải pháp có thể được sử dụng cho tất cả các loại tài liệu cần được xác minh.</p>
                <p className='text-white pt-30'>Qrypto là một thiết kế thực sự đa mục đích, phù hợp với <strong>môi trường giáo dục</strong>,<strong> doanh nghiệp</strong> hoặc <strong>chính phủ</strong>. Đây là một hệ thống nhẹ có thể dễ dàng tích hợp với các <strong>quy trình sản xuất tài liệu</strong> hiện có của bạn. Điều tuyệt vời nhất là Ứng dụng di động của chúng tôi giúp mọi người dễ dàng <strong>xác thực tức thì</strong> cả <strong>tài liệu vật lý</strong> và <strong>điện tử</strong>.</p>
                <p className='text-white pt-30'>Một hệ thống chỉ hoạt động như thế!</p>
                <PrimaryButton href='/industries' className='mt-20'>Tìm hiểu thêm</PrimaryButton>
              </div>
            }

          </div>


          <div className='secure-document_content bg-FFECE6 col-md-12 mt-50 p-x30-y50' onMouseMove={handleMouseMove2}>
            <div className='blur-red' style={{
              left: mousePosition2.x - 500 + 'px',
              top: mousePosition2.y - 500 + 'px'
            }} />
            <div className='col-md-7 pt-20 pr-50 index-10'>
              <p className='font-24 pt-20'>{t('home-page.secure-document.title')}</p>
              <p className='pt-20'>{t('home-page.secure-document.sub-title')}</p>
              <div className='flex'>
                <img src={icon_checked_red} alt='checked_red' className='pr-5 mt--10' />
                <p className='pt-20'>
                  <strong>{t('home-page.secure-document.on-premise-software')}</strong>: {t('home-page.secure-document.on-premise-software-content')}</p>
              </div>
              <div className='flex'>
                <img src={icon_checked_red} alt='checked_red' className='pr-5 mt--10' />
                <p className='pt-20'><strong>{t('home-page.secure-document.qrypto-cloud')}</strong>: {t('home-page.secure-document.qrypto-cloud-content')}</p>
              </div>
              <div className='flex'>
                <img src={icon_checked_red} alt='checked_red' className='pr-5 mt--10' />
                <p className='pt-20'><strong>{t('home-page.secure-document.hybird')}</strong>: {t('home-page.secure-document.hybird-content')}</p>
              </div>
              <PrimaryButton2th className='mt-20 mb-20' href="/technology/deployment">{t('button.learn-more')}</PrimaryButton2th>
            </div>
            <div className='col-md-5 index-10'>
              <img src={deployment_img} alt='document' className='document-img img-responsive pt-70' />
            </div>
          </div>
        </div>

        <div className='home-features container pt-100'>
          <div className='col-sm-12'>
            {language === "en"
              ?
              <p className='text-white text-center font-42 pb-50 font-weight-semi-bold'><span className='text-primary-orange'>Features</span> at a glance</p>
              :
              <p className='text-white text-center font-42 pb-50 font-weight-semi-bold'><span className='text-primary-orange'>Các tính năng</span> trong nháy mắt</p>
            }
          </div>
          <div className='features-list pt-50'>
            <div className='row'>
              <div className='col-lg-3 col-md-4 col-sm-6 features-list_item'>
                <img src={icon_checked_shield_red} alt="checked_shield_red" />
                <p className='text-white font-24 pt-10 font-weight-semi-bold'>{t('home-page.features-glance.security')}</p>
                <p className='text-gray pt-20'>{t('home-page.features-glance.security-content')}</p>
              </div>
              <div className='col-lg-3 col-md-4 col-sm-6 features-list_item'>
                <img src={icon_star_checked} alt="star_checked" />
                <p className='text-white font-24 pt-10 font-weight-semi-bold'>{t('home-page.features-glance.instant-validation')}</p>
                <p className='text-gray pt-20'>{t('home-page.features-glance.instant-validation-content')}</p>
              </div>
              <div className='col-lg-3 col-md-4 col-sm-6 features-list_item'>
                <img src={icon_database} alt="no_database" />
                <p className='text-white font-24 pt-10 font-weight-semi-bold'>{t('home-page.features-glance.no-database')}</p>
                <p className='text-gray pt-20'>{t('home-page.features-glance.no-database-content')}</p>
              </div>
              <div className='col-lg-3 col-md-4 col-sm-6 features-list_item'>
                <img src={icon_hand_book} alt="hand_open_book" />
                <p className='text-white font-24 pt-10 font-weight-semi-bold'>{t('home-page.features-glance.paper-electronic')}</p>
                <p className='text-gray pt-20'>{t('home-page.features-glance.paper-electronic-content')}</p>
              </div>
              <div className='col-lg-3 col-md-4 col-sm-6 features-list_item'>
                <img src={icon_arrow_tv} alt="arrow_tv" />
                <p className='text-white font-24 pt-10 font-weight-semi-bold'>{t('home-page.features-glance.easy-integration')}</p>
                <p className='text-gray pt-20'>{t('home-page.features-glance.easy-integration-content')}</p>
              </div>
              <div className='col-lg-3 col-md-4 col-sm-6 features-list_item'>
                <img src={icon_cloud_lifecycle} alt="cloud_lifecycle" />
                <p className='text-white font-24 pt-10 font-weight-semi-bold' >{t('home-page.features-glance.simple-pricing-model')}</p>
                <p className='text-gray pt-20'>{t('home-page.features-glance.simple-pricing-model-content')}</p>
              </div>
              <div className='col-lg-3 col-md-4 col-sm-6 features-list_item'>
                <img src={icon_hammer_wrench} alt="hammer_wrench" />
                <p className='text-white font-24 pt-10 font-weight-semi-bold'>{t('home-page.features-glance.stellar-support')}</p>
                <p className='text-gray pt-20'>{t('home-page.features-glance.stellar-support-content')}</p>
              </div>
              <div className='col-lg-3 col-md-4 col-sm-6 features-list_item'>
                <img src={icon_paper_red} alt="paper_red" />
                <p className='text-white font-24 pt-10 font-weight-semi-bold'>{t('home-page.features-glance.certificate-pdf')}</p>
                <p className='text-gray pt-20'>{t('home-page.features-glance.certificate-pdf-content')}</p>
              </div>
            </div>
          </div>
        </div>

        <div className='testimonial container pb-50'>
          <div className='col-sm-12 text-center mt--50'>
            <p className='font-42 font-weight-semi-bold text-primary-orange'>{t('home-page.testimonial.title')}</p>
            {language === "en" ?
              <p className='text-gray textcenter pt-20'>What Our <strong>Satisfied Customers</strong> Have to Say</p>
              :
              <p className='text-gray textcenter pt-20'>Phản hồi từ <strong>khách hàng</strong></p>
            }
          </div>
        </div>



        <div className='container-fuild relative'>
          <div className='blur-carousel-left'></div>
          <div className='blur-carousel-left'></div>
          <HomeCarousel />
          <div className='blur-carousel-right'></div>
          <div className='blur-carousel-right'></div>
        </div>

        <div className='efficient-system container pt-100'>
          {language === "en" ?
            <div className='col-sm-8 col-sm-offset-2 text-center pb-20'>
              <p className='font-42 text-white font-weight-semi-bold'>Trustworthy credentials are the bedrock of an <span className='text-primary-orange'>efficient system</span></p>
              <p className='text-gray text-center pt-20'>Qrypto is perfect for <strong>small</strong> organizations, <strong>large</strong> enterprises and <strong>governments</strong> alike.</p>
            </div>
            :
            <div className='col-sm-10 col-sm-offset-1 text-center pb-20'>
              <p className='font-42 text-white font-weight-semi-bold'>Thông tin xác thực đáng tin cậy là nền tảng của một <span className='text-primary-orange'>hệ thống hiệu quả</span></p>
              <p className='text-gray text-center pt-20'>Qrypto hoàn hảo cho các tổ chức <strong>nhỏ</strong>, doanh nghiệp <strong>lớn</strong> cũng như <strong>chính phủ</strong>.</p>
            </div>
          }
          <div className='col-sm-12'>
            <HomeSlider />
          </div>

        </div>

        <div className='organizations-brands container-fluid bg-E5F8FB pt-50 mt-100'>
          <div className='container'>
            <div className='col-sm-12'>
              {language === "en" ?

                <p className='font-weight-semi-bold font-42 text-center'>Leading <span className='text-primary-orange'>organizations</span> and <span className='text-primary-orange'>brands</span> rely on Qrypto</p>
                :
                <div className='col-sm-8 col-sm-offset-2'>
                  <p className='font-weight-semi-bold font-42 text-center'>
                    <span className='text-primary-orange'>Các tổ chức</span> và <span className='text-primary-orange'>thương hiệu</span> hàng đầu tin tưởng vào Qrypto
                  </p>
                </div>
              }

              <ul className='list-inline text-center pt-20 pb-30'>
                <li>
                  <img src={UEH_color_logo} alt="UEH_logo" className='client-s-150' />
                </li>
                <li>
                  <img src={UIT_color_logo} alt="UIT_logo" className='client-s-150' />
                </li>
                <li>
                  <img src={TDT_color_logo} alt="TDT_logo" className='client-s-150' />
                </li>
                <li>
                  <img src={HUTECH_color_logo} alt="HUTECH_logo" className='client-s-150' />
                </li>
                <li>
                  <img src={VANLANG_color_logo} alt="vanlang_logo" className='client-s-150' />
                </li>
                <li>
                  <img src={USTH_color_logo} alt="USTH_logo" className='client-s-150' />
                </li>
                <li>
                  <img src={FPT_color_logo} alt="FPT_logo" className='client-s-150' />
                </li>
                <li>
                  <img src={VNU_color_logo} alt="VNU_logo" className='client-s-150' />
                </li>
                <li>
                  <img src={PTIT_color_logo} alt="PTIT_logo" className='client-s-150' />
                </li>
                <li>
                  <img src={BK_color_logo} alt="BK_logo" className='client-s-150' />
                </li>

              </ul>
            </div>
          </div>
        </div>
        <div className='pb-50 pt-100'>
          <HomeTabCarousel />
        </div>
      </div>
      <Footer />
      {modalDiscussionOpen && <ModalContactDiscussionForm setOpenModal={setModalDiscussionOpen} handleOverlayClick={handleOverlayClick} modalRef={modalDiscussionRef} />}
    </div>
  )
}

export default Home